import { AppConfig } from 'src/app/app-config.service';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatSelect } from '@angular/material/select';

/*
SalesOrder type drop-down selector component
caches OrderType selection in browser sessionStorage and persists throughout application

<mayer-so-type-selector

// two-way data-binding to a property
[(value)]="soOrderType"

// event handler when drop-down value is changed
(onChange)="soTypeChanged()">
</mayer-so-type-selector>

*/

const salesordertypeSessionKey = 'mayer-so-type';

@Component({
  selector: 'mayer-so-type-selector',
  templateUrl: './so-type-selector.component.html',
  styleUrls: ['./so-type-selector.component.css'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    multi: true,
    useExisting: SOTypeSelectorComponent
  }]
})
export class SOTypeSelectorComponent implements OnInit, ControlValueAccessor {
  @ViewChild('selector')
  private selectorControl!: MatSelect;
  selectorFormControl = new FormControl();
  soTypes = AppConfig.settings.acumatica.SalesOrderTypes;

  constructor() { }

  // event emitter for client subscribers
  @Output() onChange = new EventEmitter<string | undefined>();

  // set focus to the selector
  focus() { this.selectorControl?.focus(); }

  // ControlValueAccessor interface
  writeValue(value: string | undefined): void { this.value = value; }
  private _onChange: any;
  registerOnChange(fn: any): void { this._onChange = fn; }
  private _onTouched: any;
  registerOnTouched(fn: any): void { this._onTouched = fn; }
  setDisabledState(disabled: boolean) { this.disabled = disabled; }

  private _initialized = false;
  ngOnInit(): void {
    // when the selector is changed through the form control
    this.selectorFormControl.valueChanges.subscribe(value => {
      if (!this._initialized) return;
      this.storeValue(value);
      this.notifyOnChange();
    });

    // use timeout to ensure <mat-select> is initialized
    setTimeout(() => {
      // when not initialized via FormControl('value')
      if (this.value === null || this.value === undefined) {
        // initialize selector from browser stored value
        this.value = sessionStorage.getItem(salesordertypeSessionKey) || "SO";
        this._onChange(this.value);
      }
      this.selectorFormControl.setValue(this.value);
      this.storeValue(this.value);
      this._initialized = true;
    });
  }

  // map this component's "value" property to the selector form control value
  @Input()
  get value(): string | undefined { return this.selectorFormControl.value; }
  set value(value) {
    this.selectorFormControl.setValue(value);
  }

  @Input()
  get disabled(): boolean { return this.selectorControl.disabled; }
  set disabled(state: boolean) { this.selectorControl.disabled = state; }

  private storeValue(value: string | null) {
    if (value !== null) sessionStorage.setItem(salesordertypeSessionKey, value);
    else sessionStorage.removeItem(salesordertypeSessionKey);
  }

  private _touched = false;
  markAsTouched() {
    if (!this._touched) {
      this._onTouched();
      this._touched = true;
    }
  }

  notifyOnChange() {
    this.markAsTouched();
    this._onChange(this.value);
    this.onChange.emit(this.value);
  }
}